
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/egypt/speakers/[id]",
      function () {
        return require("private-next-pages/egypt/speakers/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/egypt/speakers/[id]"])
      });
    }
  